module.exports = __webpack_public_path__ + "img/green_004.8676feb6.png";